export default __webpack_public_path__ + "static/media/web_image.3725c2fe.svg";